import React, { PureComponent } from 'react';

import { FormattedMessage, injectIntl, InjectedIntl } from 'react-intl';

import CustomThemeButton from '@atlaskit/button/custom-theme-button';
// @ts-ignore TODO: fix noImplicitAny error here
import EmptyState from '@atlaskit/empty-state';

import urls from '../urls';

import messages from './empty-state.i18n';
import emptyStateImgUrl from './empty-state.svg';

export type BranchesEmptyStateProps = {
  intl: InjectedIntl;
};

class BranchesEmptyState extends PureComponent<BranchesEmptyStateProps> {
  render() {
    const { intl } = this.props;
    return (
      <EmptyState
        description={intl.formatMessage(messages.description)}
        header={intl.formatMessage(messages.header)}
        imageUrl={emptyStateImgUrl}
        maxImageHeight={213}
        maxImageWidth={246}
        primaryAction={
          <CustomThemeButton
            appearance="primary"
            href={urls.external.branchesEmptyStateLearnHow}
          >
            <FormattedMessage {...messages.learnMoreLink} />
          </CustomThemeButton>
        }
      />
    );
  }
}

export default injectIntl(BranchesEmptyState);
